import React, { useState, useEffect } from "react";
import ActionBar from "../common/ActionBar";
import Dashboard from "./Home/index";
import BookingDetail from "./Bookings/BookingDetail";
import BookingService from "../../services/BookingService";
import useLoader from "../../hooks/useLoader";
import { useSnackbar } from "notistack";
import styled from "styled-components";

const Index = () => {
  const [openBooking, setOpenBooking] = useState(null);
  const handleOpenBooking = (b) => setOpenBooking(b);
  const handleCloseBooking = () => setOpenBooking(null);
  const { setLoader, setShowDrawer } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState();

  useEffect(() => {
    async function fetchBookingDashboard() {
      try {
        setLoader({ state: true, message: "Fetching booking dashboard..." });
        const response = await BookingService.fetchBookingDashboard();
        setState(response?.data);
      } catch (error) {
        enqueueSnackbar(error?.message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        setShowDrawer(true);
      }
    }
    setShowDrawer(true);
    fetchBookingDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ActionBar breadcrumbs={["Booking Dashboard"]} />
      <Padding>
        <Dashboard
          onOpenBooking={handleOpenBooking}
          {...{ handleCloseBooking, state }}
        />
      </Padding>

      <BookingDetail booking={openBooking} onClose={handleCloseBooking} />
    </>
  );
};

export default Index;

const Padding = styled.div`
  padding-top: 30px;
  padding-bottom: 50px;
`;
